import { StyleSheet } from 'react-native';

export const Styles = StyleSheet.create({
  textInput: {
    fontSize: 16,
    alignSelf: 'stretch',
  },
});
